<template>
  <c-row>
    <loader v-show="loading" />
    <c-col col="5">
      <c-card>
        <c-card-header>
          <strong>Item Detail</strong>
        </c-card-header>
        <c-card-body>
          <c-form>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">Code</label>
              <div class="col-sm-7">
                <input type="text" class="form-control" v-bind:class="{ 'has-error': hasError.code }"
                  v-model="product.code" placeholder="Code" :readonly="query && query.code && query.code !== 'auto'" />
              </div>
              <div class="col-sm-1">
                <CButton color="secondary" v-c-tooltip.hover.click="'Auto generate code'" @click="autoCode">
                  <i class="cil-sync"></i>
                </CButton>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">Unit</label>
              <div class="col-sm-9">
                <select-x url="/api/v1/unit" :size="100" placeholder="--Pilih Satuan--" v-model="product.unit"
                  label="unit" v-bind:class="{ 'has-error': hasError.unit_id }" />
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">Product Name</label>
              <div class="col-sm-9">
                <textarea class="form-control" v-bind:class="{ 'has-error': hasError.name }" v-model="product.name"
                  placeholder="Product Name" />
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">Description</label>
              <div class="col-sm-9">
                <textarea class="form-control" v-bind:class="{ 'has-error': hasError.description }"
                  v-model="product.description" placeholder="Product Description" />
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">Min Stock</label>
              <div class="col-sm-9">
                <input type="number" class="form-control unicode right" v-bind:class="{ 'has-error': hasError.min_stock }"
                  v-model="product.min_stock" placeholder="Min Stock" />
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">Base Price</label>
              <div class="col-sm-9">
                <input type="text" id="price" v-model="basePriceFormat" @input="onBasePriceInput($event)"
                  class="form-control text-right" />
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-3">Service</label>
              <div class="col-sm-9">
                <vue-select :options="options" v-model="product.type" />
              </div>
            </div>
          </c-form>
        </c-card-body>
        <c-card-footer>
          <div class="button-group">
            <button type="button" class="btn btn-success" @click="save" v-show="!product.id">
              <i class="cil-save"> </i> Simpan
            </button>
            <button type="button" class="btn btn-success" @click="update" v-show="product.id">
              <i class="cil-cloud-upload"> </i> Update
            </button>
            <button type="button" class="btn btn-warning" @click="reset">
              <i class="cil-reload"></i> Reset
            </button>
          </div>
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="7">
      <c-card>
        <c-card-header>
          <strong>Price List</strong>
          <div class="card-header-actions">
            <a class="link btn btn-outline-success" @click="addNewPrice">
              <i class="cil-plus"></i>
            </a>
          </div>
        </c-card-header>
        <c-card-body>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Type</th>
                <th>Method</th>
                <th>Effective date</th>
                <th>Price</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in product.prices" :key="k">
                <td>{{ v.type.name }}</td>
                <td>
                  <label :class="`label label-${v.payment_method.slug}`">
                    {{ v.payment_method.label }}
                  </label>
                </td>
                <td class="unicode">{{ v.effective_date | dateTimeFormat }}</td>
                <td class="right unicode">{{ v.price | thousandSeparator }}</td>
                <td>
                  <CButton class="btn-outline-info btn btn-action" v-c-tooltip.hover.click="'Ubah'" @click="doEdit(v)">
                    <i class="cil-pencil"></i>
                  </CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
      </c-card>
    </c-col>
    <CModal title="Added Price List" size="sm" color="success" :show.sync="showPriceForm" role="dialog"
      data-backdrop="static" data-keyboard="false" @hide="handleHide">
      <div class="form-group">
        <label>Type</label>
        <select-x url="/api/v1/customer-type" label="name" v-model="edit.type" />
      </div>
      <div class="form-group">
        <label>Method</label>
        <select-x url="/api/v1/payment-method" v-model="edit.payment_method" />
      </div>
      <div class="form-group">
        <label>Price</label>
        <input type="text" id="price" v-model="priceFormat" @input="onPriceInput($event)"
          class="form-control text-right" />
      </div>
      <template #footer>
        <CButton @click="showPriceForm = false" color="danger">Keluar</CButton>
        <CButton @click="priceSave" color="success">Simpan</CButton>
      </template>
    </CModal>
  </c-row>
</template>
<script>
import SelectX from "../../components/SelectX";
import Loader from "../../components/Loader";
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage } from '../../lib/helpers';
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    SelectX,
    Loader,
    VueSelect,
  },
  computed: {
    basePriceFormat: {
      get () {
        return this.basePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      set (value) {
        this.basePrice = value.replace(/[^\d]/g, '');
      }
    },
    priceFormat: {
      get () {
        return this.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      set (value) {
        this.price = value.replace(/[^\d]/g, '');
      }
    }
  },
  data () {
    return {
      product: {
        code: "",
        unit: null,
        type: { label: 'product' }
      },
      edit: {},
      hasError: {},
      query: {
        code: ''
      },
      options: [
        { label: 'product' },
        { label: 'service' },
      ],
      showPriceForm: false,
      loading: false,
      basePrice: '',
      price: '',
    }
  },
  created () {
    const query = this.$route.query;
    if (query.id) {
      this.get(query.id);
    }
    this.query = query;
  },
  methods: {
    onBasePriceInput (event) {
      const value = event.target.value;
      this.basePrice = value.replace(/[^\d]/g, '');
    },
    onPriceInput (event) {
      const value = event.target.value;
      this.price = value.replace(/[^\d]/g, '');
    },
    handleHide () {
      console.log(9)
    },
    get (id) {
      this.loading = true;
      HTTPAUTH.get("/api/v1/product/" + id).then(res => {
        this.product = res.data.data;
        this.basePrice = this.product.price_buy;
        this.loading = false;
      }).catch(eres => {
        showErrorMessage(eres)
        this.loading = false;
      })
    },
    getPriceList (id) {
      this.loading = true;
      HTTPAUTH.get("/api/v1/product/price-list/" + id).then(res => {
        this.product.prices = res.data.data;
        this.loading = false;
      }).catch(eres => {
        showErrorMessage(eres)
        this.loading = false;
      })
    },
    save () {
      if (this.basePrice) {
        this.product.price_buy = this.basePrice
      }
      this.product.unit_id = this.product.unit.id;
      HTTPAUTH.post("/api/v1/product", this.product).then((res) => {
        this.$toasted.success("Berhasil disimpan").goAway(2000);
        this.$router.push({ query: { id: res.data.data.id } })
        this.product = res.data.data
        // this.reset();
      }).catch(eres => {
        this.$toasted.error(eres.response.data.message).goAway(3000);
        this.hasError = eres.response.data.errors;
      })
    },
    update () {
      if (this.basePrice) {
        this.product.price_buy = this.basePrice
      }
      this.product.unit_id = this.product.unit.id;
      HTTPAUTH.put("/api/v1/product/" + this.product.id, this.product).then(() => {
        this.$toasted.success("Berhasil disimpan").goAway(2000);
        // this.reset();
      }).catch(eres => {
        this.$toasted.error(eres.response.data.message).goAway(3000);
        this.hasError = eres.response.data.errors;
      })
    },
    reset () {
      this.product = {};
      this.$router.push({ query: {} })
    },
    autoCode () {
      const query = this.$route.query;
      this.query = query
      const id = (query.id) ? query.id : null;
      const code = (query.code ? (query.code === 'auto' ? "no" : "auto") : "auto");
      if (code === "auto") {
        const timestamp = moment();
        this.product.code = Math.ceil(timestamp.format("x") / 1000);
      } else {
        this.product.code = "";
      }
      this.$router.push({ query: { id: (id ? id : ""), code: code } })
    },
    doEdit (v) {
      this.edit = v
      this.showPriceForm = true
      this.price = v.price
    },
    priceSave () {
      if (this.price) {
        this.edit.price = this.price;
      }
      this.edit.item_id = this.product.id;
      HTTPAUTH.post("/api/v1/product/price", this.edit).then(() => {
        this.getPriceList(this.product.id);
        this.showPriceForm = false
        this.$teasted.success("berhasil ubah price list").goAway()
      }).catch(eres => {
        showErrorMessage(eres)
      })
    },
    addNewPrice () {
      this.edit = {};
      this.showPriceForm = true
    }
  },
}
</script>
